export default "__VITE_ASSET__AWETdH01__"